import type {
	UserCheck,
	UserCheckFound,
	UserCheckMissing,
	UserCheckUpdateFound,
	UserCheckUpdateMissing,
	UserCreate,
	UserUpdate,
} from "@/shared/api/generated-backend"
import {
	checkUserExistsApiV1AuthCheckUserPost,
	deleteUserEndpointApiV1AuthUserDeleteUserIdDelete,
	getAvatarsApiV1AuthAvatarsGet,
	getUserInfoByIdApiV1AuthUserUserIdGet,
	registerApiV1AuthRegisterPost,
	updateUserApiV1AuthUpdateUserPost,
} from "@/shared/api/generated-backend"
import { getValidAccessToken } from "@/shared/api/http"
import { env } from "@/shared/config/env"
import { requireUpdate } from "@/shared/lib/app-update/update-required"
import { getPlatformIdentity } from "@/shared/lib/platform"
import { getDeviceTimezone } from "@/shared/lib/timezone"
import type { User } from "../model/types"

export type CheckUserResult = UserCheckUpdateFound | UserCheckUpdateMissing

export type CachedAuthResult =
	| Pick<UserCheckFound, "exists" | "user">
	| UserCheckMissing

export async function checkUser(params: UserCheck): Promise<CheckUserResult> {
	const token = await getValidAccessToken()
	const headers: Record<string, string> = {}
	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	if (env.VITE_PUBLIC_APP_VERSION) {
		headers["X-Webapp-Version"] = env.VITE_PUBLIC_APP_VERSION
	}
	const result = await checkUserExistsApiV1AuthCheckUserPost({
		body: params,
		headers,
	})
	if (result.update_screen) {
		requireUpdate()
	}
	return result
}

export async function getUserById(intUserId: number): Promise<User> {
	return getUserInfoByIdApiV1AuthUserUserIdGet({
		path: { user_id: intUserId },
	})
}

export async function registerUser(payload: UserCreate) {
	const body: UserCreate = { ...payload }
	const { device_id } = await getPlatformIdentity()
	if (device_id !== undefined) body.device_id = device_id
	const timezone = getDeviceTimezone()
	if (timezone !== undefined) body.timezone = timezone

	return registerApiV1AuthRegisterPost({ body })
}

export async function updateUser(payload: UserUpdate) {
	return updateUserApiV1AuthUpdateUserPost({
		body: payload,
	})
}

export async function deleteUserAccount(intUserId: number, reason: string) {
	await deleteUserEndpointApiV1AuthUserDeleteUserIdDelete({
		path: { user_id: intUserId },
		body: { reason },
	})
}

export async function getAvatars() {
	return getAvatarsApiV1AuthAvatarsGet()
}
